// extracted by mini-css-extract-plugin
module.exports = {"inputHint":"InputHint_inputHint__UExzu","closeHint":"InputHint_closeHint__1fv8c"};